import { CONFIG_POLICY_SERVE_FLAG, getConfigPolicy } from '../configPolicy';

export const isFeatureActive = flagName => {
  try {
    const flags = JSON.parse(localStorage.getItem('featureFlags'));
    // AUTH-1462: only districts in the legacy CONFIG_POLICY_SERVE_FLAG cohort get answers from
    // the new flags library, once hcp-container has loaded it.
    if (flags?.includes(CONFIG_POLICY_SERVE_FLAG)) {
      const configPolicy = getConfigPolicy();
      if (configPolicy) {
        return configPolicy.isEnabled(flagName);
      }
    }
    return flags?.includes(flagName);
  } catch (e) {
    return false;
  }
};

export default isFeatureActive;
